import React, { useEffect, useState } from "react";
import TextAreaQuill from "../../../../general/components/Textarea/Quilljs/TextAreaQuill";
import { classNames } from "../../../../general/functions/propsComponent";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import { PostKonselorSession } from "../../actions/KonselorSessionActions";
import { useDispatch, useSelector } from "react-redux";

// Gagal Menyimpan, Tersipman, Belum Disimpan

const handleStatusSimpan = (indikator) => {
  switch (indikator) {
    case 1:
      return {
        indikator: 1,
        label: "Draf Belum Disimpan",
        bgColor: "bg-gray-500",
      };
    case 2:
      return { indikator: 2, label: "Draf Tersimpan", bgColor: "bg-green-500" };
    case 3:
      return {
        indikator: 3,
        label: "Draf Gagal Disimpan",
        bgColor: "bg-red-500",
      };
    default:
      return { indikator: 0, label: "", bgColor: "" };
  }
};

export default function KesimpulanSaranSession() {
  const { dataSessionPduli } = useSessionDataPduli({});
  const [loading, setLoading] = useState(false);
  const [statusSimpan, setStatusSimpan] = useState({
    kesimpulan: handleStatusSimpan(),
    saran: handleStatusSimpan(),
  });
  const [savedData, setSavedData] = useState({
    kesimpulan: dataSessionPduli?.result?.conclusion,
    saran: dataSessionPduli?.result?.suggestion,
  });
  const [kesimpulanVal, setKesimpulanVal] = useState(
    dataSessionPduli?.result?.conclusion
  );
  const [saranVal, setSaranVal] = useState(
    dataSessionPduli?.result?.suggestion
  );
  const [textEditorOn, setTextEditorOn] = useState(null);

  useEffect(() => {
    setKesimpulanVal(dataSessionPduli?.result?.conclusion);
    setSaranVal(dataSessionPduli?.result?.suggestion);
  }, [
    dataSessionPduli?.result?.conclusion,
    dataSessionPduli?.result?.suggestion,
  ]);
  const dispatch = useDispatch();
  const storePost = useSelector((state) => state.km_post_koselor_session);
  useEffect(() => {
    if (storePost.success) {
      setLoading(false);
      setStatusSimpan({
        kesimpulan: handleStatusSimpan(2),
        saran: handleStatusSimpan(2),
      });
      setSavedData({ kesimpulan: kesimpulanVal, saran: saranVal });
    }
    if (storePost.error) {
      setLoading(false);
      setStatusSimpan((prev) => {
        let dKesimpulan = prev.kesimpulan;
        let dSaran = prev.saran;
        if (dKesimpulan?.indikator != 2 && dKesimpulan?.indikator != 0) {
          dKesimpulan = handleStatusSimpan(3);
        }
        if (dSaran?.indikator != 2 && dSaran?.indikator != 0) {
          dSaran = handleStatusSimpan(3);
        }
        return {
          kesimpulan: dKesimpulan,
          saran: dSaran,
        };
      });
    }
  }, [storePost]);
  const handleSubmit = () => {
    let kesimpulan = "";
    let saran = "";
    if (kesimpulan != null) {
      kesimpulan = kesimpulanVal;
    }
    if (saran != null) {
      saran = saranVal;
    }
    setLoading(true);
    dispatch(PostKonselorSession(kesimpulan, saran));
  };
  console.log("dataSessionPduli?.result", dataSessionPduli?.result);
  return (
    <div className="bg-secondary-600 p-5 rounded-md">
      <div>
        <h2 className="font-semibold  text-primary-500 text-sm">
          Kesimpulan / Diagnosa (Draf)
        </h2>

        <div
          className="bg-white mt-1 mb-2 kesimpulan-saran-part relative"
          onClick={() => {
            setTextEditorOn(1);
          }}
        >
          {textEditorOn == 1 && !loading ? (
            <TextAreaQuill
              className={"max-h-[25vh] overflow-auto"}
              value={kesimpulanVal}
              onChange={(v) => {
                setStatusSimpan((prev) => {
                  return { ...prev, kesimpulan: handleStatusSimpan(1) };
                });
                setKesimpulanVal(v);
              }}
            />
          ) : (
            <div className="ql-container ql-snow">
              <div className="ql-editor max-h-[25vh] overflow-auto">
                {kesimpulanVal == null ||
                kesimpulanVal == "" ||
                kesimpulanVal.toString() == "<p><br></p>" ? (
                  <label className="text-gray-500">Ketik sesuatu...</label>
                ) : (
                  ""
                )}
                <div
                  style={{ minHeight: "60px" }}
                  dangerouslySetInnerHTML={{
                    __html: kesimpulanVal,
                  }}
                />
              </div>
            </div>
          )}
          <div
            className={classNames(
              statusSimpan?.kesimpulan?.bgColor,
              " px-2 py-1 rounded-lg absolute bottom-1 right-1"
            )}
          >
            <p className="text-xs text-gray-100 font-bold">
              {statusSimpan?.kesimpulan?.label}
            </p>
          </div>
        </div>
      </div>
      <div className="">
        <h2 className="font-semibold  text-primary-500 text-sm">
          Saran kepada konseli (Draf)
        </h2>
        <div
          className="bg-white mt-1 mb-2  kesimpulan-saran-part relative"
          onClick={() => {
            setTextEditorOn(2);
          }}
        >
          {textEditorOn == 2 && !loading ? (
            <TextAreaQuill
              className={"max-h-[25vh] overflow-auto"}
              value={saranVal}
              onChange={(v) => {
                console.log(v);
                setStatusSimpan((prev) => {
                  return { ...prev, saran: handleStatusSimpan(1) };
                });
                setSaranVal(v);
              }}
            />
          ) : (
            <div className="ql-container ql-snow">
              <div className="ql-editor max-h-[25vh] overflow-auto">
                {saranVal == null ||
                saranVal == "" ||
                saranVal.toString() == "<p><br></p>" ? (
                  <label className="text-gray-500">Ketik Sesuatu...</label>
                ) : (
                  ""
                )}
                <div
                  style={{ minHeight: "60px" }}
                  dangerouslySetInnerHTML={{
                    __html: saranVal,
                  }}
                />
              </div>
            </div>
          )}
          <div
            className={classNames(
              statusSimpan?.saran?.bgColor,
              " px-2 py-1 rounded-lg absolute bottom-1 right-1"
            )}
          >
            <p className="text-xs text-gray-100 font-bold">
              {statusSimpan?.saran?.label}
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-start">
        <button
          className={classNames(
            "btn-primary p-2 w-auto flex flex-col justify-center items-center whitespace-nowrap"
          )}
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <p className="text-sm font-semibold">Simpan</p>
        </button>
      </div>
    </div>
  );
}
